export interface IDestinationReasonsState {
    destinationReasons: any[];
    selectedDestinationReason: any;
  }
  
  export const initialDestinationReasonsState: IDestinationReasonsState = {
    destinationReasons: [],
    selectedDestinationReason: null
  };